import WCCAttachment, { JSONWCCAttachment } from './attachment';

export default class WCCYoutubeVideo extends WCCAttachment<JSONWCCAttachment> {
    cFullLink = ko.pureComputed(() => 'https://www.youtube.com/embed/' + this.link()) //Bh93YV8D5rM
}